const _i18n_info = {
  detected_info : {
    EN: `No Site Detected`,
    KO: `No Site Detected`,
    JP: `サイトが検出されませんでした`
  }
}

const i18n_toastr = { _i18n_info }

export default i18n_toastr